// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2716%27 height=%2716%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%2394A3B8%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Cpath d=%27m6 9 6 6 6-6%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * RobiTest design refresh — canonical visual layer over the existing token system.
 * Loaded last (App.js) so it resolves conflicts between ui.css, rt2-primitives.css
 * and legacy page styles. Uses only tokens from theme/tokens.css.
 */

/* ── Base ─────────────────────────────────────────────────────────── */
html {
  text-rendering: optimizeLegibility;
}

::selection {
  background: var(--primary-muted);
  color: var(--text-primary);
}

:where(button, a, input, textarea, select, [tabindex]):focus-visible {
  outline: 2px solid var(--primary);
  outline-offset: 2px;
}

.rt2-main {
  font-size: var(--type-body);
  line-height: var(--leading-normal);
  color: var(--text-primary);
  scroll-behavior: smooth;
  scrollbar-gutter: stable;
}

.rt2-main,
.rt2-main *:not(svg):not(path) {
  text-shadow: none !important;
}

/* ── Page chrome ──────────────────────────────────────────────────── */
.rt2-main .rt-page-header {
  gap: 16px;
  margin-bottom: 20px;
}

.rt2-main .rt-page-header__title {
  font-size: var(--type-page-title);
  font-weight: 650;
  letter-spacing: -0.022em;
  line-height: var(--leading-tight);
  color: var(--text-primary);
}

.rt2-main .rt-page-header__desc,
.rt2-main .rt-page-header__subtitle {
  font-size: 13.5px;
  color: var(--text-secondary);
  max-width: 68ch;
}

.rt-breadcrumbs,
.rt-page-header__crumbs {
  font-size: var(--type-supporting);
  color: var(--text-muted);
}

.rt-breadcrumbs__current {
  color: var(--text-secondary);
  font-weight: 600;
}

.rt2-main .rt-section-header__title,
.rt2-main .rt-section-card__title {
  font-size: var(--type-section-title);
  font-weight: 600;
  letter-spacing: -0.01em;
  color: var(--text-primary);
}

/* ── Surfaces ─────────────────────────────────────────────────────── */
.rt-section-card,
.rt-metric-card,
.rt-context-strip,
.rt-data-table-wrap,
.rt-filter-bar {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-xs);
}

.rt-metric-card {
  transition: border-color var(--duration-normal) ease, box-shadow var(--duration-normal) ease,
    transform var(--duration-normal) var(--ease-out);
}

/* Metric cards: accent tone, soft wash, and hover feedback. */
.rt-metric-card {
  --metric-accent: #64748b;
  position: relative;
  overflow: hidden;
  isolation: isolate;
  min-height: 108px;
  padding: 14px 16px 16px;
  background:
    linear-gradient(180deg, color-mix(in srgb, var(--surface) 92%, #fff) 0%, var(--surface) 100%);
}

.rt-metric-card--primary { --metric-accent: var(--primary); }
.rt-metric-card--success { --metric-accent: var(--success); }
.rt-metric-card--danger { --metric-accent: var(--danger); }
.rt-metric-card--warning { --metric-accent: var(--warning); }
.rt-metric-card--info { --metric-accent: #0284c7; }
.rt-metric-card--accent { --metric-accent: #0EA5E9; }
.rt-metric-card--violet { --metric-accent: #8B5CF6; }
html[data-theme='dark'] .rt-metric-card {
  background: linear-gradient(180deg, color-mix(in srgb, var(--surface) 88%, #1e293b) 0%, var(--surface) 100%);
}
html[data-theme='dark'] .rt-metric-card--info { --metric-accent: #38bdf8; }
html[data-theme='dark'] .rt-metric-card--accent { --metric-accent: #38BDF8; }
html[data-theme='dark'] .rt-metric-card--violet { --metric-accent: #A78BFA; }

.rt-metric-card::before,
.rt-metric-card::after {
  content: '';
  position: absolute;
  pointer-events: none;
  transition: opacity var(--duration-normal) ease;
  z-index: -1;
}

.rt-metric-card::before {
  inset: 0 0 auto 0;
  height: 3px;
  opacity: 1;
  background: linear-gradient(90deg, var(--metric-accent), color-mix(in srgb, var(--metric-accent) 20%, transparent) 90%);
  z-index: 1;
}

.rt-metric-card::after {
  inset: 0;
  opacity: 0.55;
  background: radial-gradient(
    120% 90% at 100% 0%,
    color-mix(in srgb, var(--metric-accent) 14%, transparent),
    transparent 62%
  );
}

.rt-metric-card:hover {
  border-color: color-mix(in srgb, var(--metric-accent) 42%, var(--border));
  box-shadow:
    0 14px 30px -16px color-mix(in srgb, var(--metric-accent) 55%, transparent),
    var(--shadow-sm);
  transform: translateY(-1px);
}

.rt-metric-card:hover::after,
.rt-metric-card:focus-visible::after {
  opacity: 1;
}

.rt-metric-card--clickable:hover,
.rt-metric-card--clickable:focus-visible {
  transform: translateY(-2px);
}

.rt-metric-card--clickable:active {
  transform: translateY(0);
  transition-duration: var(--duration-fast);
}

.rt-metric-card--clickable:focus-visible {
  outline: 2px solid color-mix(in srgb, var(--metric-accent) 60%, transparent);
  outline-offset: 2px;
}

.rt-metric-card__badge {
  position: relative;
  display: inline-flex;
  width: 28px;
  height: 28px;
  flex-shrink: 0;
}

.rt-metric-card__badge .rt-metric-card__icon,
.rt-metric-card__go {
  position: absolute;
  inset: 0;
  width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--radius-md);
  transition:
    opacity var(--duration-normal) ease,
    transform var(--duration-normal) var(--ease-out),
    background var(--duration-normal) ease,
    color var(--duration-normal) ease;
}

.rt-metric-card__badge .rt-metric-card__icon {
  background: color-mix(in srgb, var(--metric-accent) 14%, transparent);
  color: var(--metric-accent);
}

.rt-metric-card:hover .rt-metric-card__badge .rt-metric-card__icon {
  background: var(--metric-accent);
  color: #fff;
  transform: scale(1.06);
}

.rt-metric-card__go {
  background: var(--metric-accent);
  color: #fff;
  opacity: 0;
  transform: translate(-4px, 4px) scale(0.85);
}

.rt-metric-card--clickable:hover .rt-metric-card__go,
.rt-metric-card--clickable:focus-visible .rt-metric-card__go {
  opacity: 1;
  transform: none;
}

.rt-metric-card--clickable:hover .rt-metric-card__badge .rt-metric-card__icon,
.rt-metric-card--clickable:focus-visible .rt-metric-card__badge .rt-metric-card__icon {
  opacity: 0;
  transform: translate(4px, -4px) scale(0.85);
}

.rt-metric-card__body {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 10px;
  margin-top: auto;
}

.rt-metric-card__main {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}

.rt-metric-card__spark {
  flex: 0 1 46%;
  max-width: 128px;
  min-width: 56px;
  color: var(--metric-accent);
}

.rt-sparkline {
  position: relative;
  height: 36px;
  cursor: crosshair;
}

.rt-sparkline svg {
  display: block;
  width: 100%;
  height: 100%;
  overflow: visible;
  animation: rt-spark-reveal 900ms var(--ease-out) both;
}

.rt-sparkline__line {
  fill: none;
  stroke: currentColor;
  stroke-width: 1.75;
  stroke-linecap: round;
  stroke-linejoin: round;
  vector-effect: non-scaling-stroke;
  transition: stroke-width var(--duration-normal) ease;
}

.rt-sparkline__area {
  opacity: 0.75;
  transition: opacity var(--duration-normal) ease;
}

.rt-metric-card:hover .rt-sparkline__line { stroke-width: 2.25; }
.rt-metric-card:hover .rt-sparkline__area { opacity: 1; }

.rt-sparkline__dot {
  position: absolute;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: currentColor;
  box-shadow: 0 0 0 3px color-mix(in srgb, currentColor 22%, transparent);
  transform: translate(-50%, -50%);
  transition: left 120ms ease-out, top 120ms ease-out;
  animation: rt-spark-dot 900ms var(--ease-out) both;
}

.rt-metric-card:hover .rt-sparkline__dot {
  box-shadow: 0 0 0 4px color-mix(in srgb, currentColor 28%, transparent);
}

.rt-sparkline__tip {
  position: absolute;
  bottom: calc(100% + 6px);
  padding: 3px 7px;
  border-radius: 6px;
  background: var(--chart-tooltip-bg, #0f172a);
  color: var(--chart-tooltip-text, #f8fafc);
  font-size: 11px;
  font-weight: 600;
  line-height: 1.4;
  white-space: nowrap;
  pointer-events: none;
  box-shadow: var(--shadow-sm);
}

.rt-sparkline__tip em {
  margin-right: 5px;
  font-style: normal;
  font-weight: 500;
  opacity: 0.7;
}

@keyframes rt-spark-reveal {
  from { clip-path: inset(0 100% 0 0); }
  to { clip-path: inset(0 0 0 0); }
}

@keyframes rt-spark-dot {
  0%, 70% { opacity: 0; }
  100% { opacity: 1; }
}

@media (prefers-reduced-motion: reduce) {
  .rt-sparkline svg,
  .rt-sparkline__dot { animation: none; }
  .rt-metric-card--clickable:hover,
  .rt-metric-card--clickable:focus-visible { transform: none; }
}

.rt-metric-card__value {
  font-variant-numeric: tabular-nums;
  letter-spacing: -0.02em;
}

.rt-filter-bar {
  padding: 10px 12px;
  gap: 8px;
}

.rt-state {
  background: var(--surface);
  border: 1px dashed var(--border-strong);
  border-radius: var(--radius-xl);
  padding: 44px 24px;
}

.rt-state__title {
  font-size: 15px;
  font-weight: 600;
  color: var(--text-primary);
}

.rt-state__desc {
  max-width: 44ch;
  color: var(--text-secondary);
  font-size: 13px;
}

/* ── Inputs ───────────────────────────────────────────────────────── */
.rt-search {
  height: var(--control-height);
  min-width: 240px;
  background: var(--input-background);
  border: 1px solid var(--input-border);
  border-radius: var(--radius-md);
  color: var(--text-primary);
  transition: border-color var(--duration-fast) ease, box-shadow var(--duration-fast) ease;
}

.rt-search:focus-within {
  border-color: var(--primary);
  box-shadow: var(--shadow-focus);
}

.rt-search input {
  background: transparent !important;
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  color: var(--text-primary) !important;
  font-size: var(--text-sm);
}

.rt-search svg {
  color: var(--text-muted);
  flex-shrink: 0;
}

.rt2-main input:not([type='checkbox']):not([type='radio']):not([type='range']):not([type='color']):not([type='file']),
.rt2-main textarea,
.form-input,
.form-control {
  color: var(--text-primary);
  caret-color: var(--primary);
}

.rt2-main input::placeholder,
.rt2-main textarea::placeholder,
.form-input::placeholder,
.form-control::placeholder {
  color: var(--input-placeholder) !important;
  opacity: 1;
}

.form-input,
.form-control {
  background-color: var(--input-background) !important;
  border: 1px solid var(--input-border) !important;
  border-radius: var(--radius-md) !important;
  transition: border-color var(--duration-fast) ease, box-shadow var(--duration-fast) ease;
}

.form-input:hover:not(:disabled),
.form-control:hover:not(:disabled) {
  border-color: var(--border-strong) !important;
}

.form-input:focus,
.form-control:focus {
  outline: none !important;
  border-color: var(--primary) !important;
  box-shadow: var(--shadow-focus) !important;
}

.form-input:disabled,
.form-control:disabled {
  background-color: var(--surface-disabled) !important;
  color: var(--text-muted) !important;
  cursor: not-allowed;
}

.form-label {
  font-size: 13px;
  font-weight: 600;
  color: var(--text-secondary);
}

/* Remaining native selects: consistent chevron and theme colours */
.rt2-main select:not([multiple]),
[data-rt-modal-overlay] select:not([multiple]) {
  appearance: none;
  background-color: var(--input-background);
  color: var(--text-primary);
  border: 1px solid var(--input-border);
  border-radius: var(--radius-md);
  padding-right: 32px !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 16px;
}

.rt2-main select option,
[data-rt-modal-overlay] select option {
  background: var(--surface-elevated);
  color: var(--text-primary);
}

.rt2-main input[type='checkbox'],
.rt2-main input[type='radio'],
[data-rt-modal-overlay] input[type='checkbox'],
[data-rt-modal-overlay] input[type='radio'] {
  accent-color: var(--primary);
}

/* ── Buttons ──────────────────────────────────────────────────────── */
.rt-btn {
  height: var(--control-height);
  border-radius: var(--radius-md);
  font-weight: 600;
  letter-spacing: -0.005em;
  transition: background var(--duration-fast) ease, border-color var(--duration-fast) ease,
    color var(--duration-fast) ease, box-shadow var(--duration-fast) ease, transform 80ms ease;
}

.rt-btn:active:not(:disabled) {
  transform: translateY(0.5px);
}

.rt-btn:focus-visible {
  outline: none;
  box-shadow: var(--shadow-focus);
}

.rt-btn--primary {
  background: var(--primary);
  color: #fff;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.12), inset 0 1px 0 rgba(255, 255, 255, 0.08);
}

.rt-btn--primary:hover:not(:disabled) {
  background: var(--primary-hover);
}

.rt-btn--secondary {
  background: var(--surface);
  border-color: var(--border-strong);
  color: var(--text-primary);
}

.rt-btn--secondary:hover:not(:disabled) {
  background: var(--surface-hover);
}

.rt-btn--ghost {
  background: transparent;
  border-color: transparent;
  color: var(--text-secondary);
}

.rt-btn--ghost:hover:not(:disabled) {
  background: var(--surface-hover);
  color: var(--text-primary);
}

.rt-btn--sm {
  height: var(--control-height-sm);
}

.rt-btn--sm.rt-btn--icon {
  width: var(--control-height-sm);
}

/* Legacy .btn family aligned with rt-btn variants */
.rt2-main .btn-primary,
[data-rt-modal-overlay] .btn-primary {
  background: var(--primary) !important;
  border-color: var(--primary) !important;
  color: #fff !important;
  box-shadow: none !important;
  background-image: none !important;
}

.rt2-main .btn-primary:hover:not(:disabled),
[data-rt-modal-overlay] .btn-primary:hover:not(:disabled) {
  background: var(--primary-hover) !important;
  border-color: var(--primary-hover) !important;
}

.rt2-main .btn-secondary,
.rt2-main .btn-outline,
[data-rt-modal-overlay] .btn-secondary {
  background: var(--surface) !important;
  border: 1px solid var(--border-strong) !important;
  color: var(--text-primary) !important;
  background-image: none !important;
  box-shadow: none !important;
}

.rt2-main .btn-secondary:hover:not(:disabled),
.rt2-main .btn-outline:hover:not(:disabled),
[data-rt-modal-overlay] .btn-secondary:hover:not(:disabled) {
  background: var(--surface-hover) !important;
}

.rt2-main .btn-danger,
[data-rt-modal-overlay] .btn-danger {
  background: var(--danger) !important;
  border-color: var(--danger) !important;
  color: #fff !important;
  background-image: none !important;
}

/* ── Tables ───────────────────────────────────────────────────────── */
.rt-data-table-wrap,
.rt-table-wrap {
  overflow: auto;
  max-width: 100%;
}

.rt-data-table,
.rt-table {
  font-size: 13.5px;
  color: var(--text-primary);
  border-collapse: separate;
  border-spacing: 0;
}

.rt-data-table th,
.rt-table th {
  position: sticky;
  top: 0;
  z-index: 2;
  height: 40px;
  padding: 0 14px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: var(--text-muted);
  background: var(--table-header) !important;
  border-bottom: 1px solid var(--table-border);
  white-space: nowrap;
}

.rt-data-table td,
.rt-table td {
  padding: 11px 14px;
  border-bottom: 1px solid var(--table-border);
  vertical-align: middle;
  background: transparent;
}

.rt-data-table tbody tr:last-child td,
.rt-table tbody tr:last-child td {
  border-bottom: none;
}

.rt-data-table tbody tr,
.rt-table tbody tr {
  transition: background var(--duration-fast) ease;
}

.rt-data-table tbody tr:hover,
.rt-table tbody tr:hover {
  background: var(--table-hover);
}

.rt-data-table__row--clickable,
.rt-table__row--clickable {
  cursor: pointer;
}

/* Generic tables inside the app shell (legacy lists) */
.rt2-main table:not(.rt-data-table):not(.rt-table) thead th {
  background: var(--table-header);
  color: var(--text-muted);
  border-color: var(--table-border);
}

.rt2-main table:not(.rt-data-table):not(.rt-table) td {
  border-color: var(--table-border);
}

/* ── Tabs ─────────────────────────────────────────────────────────── */
.rt-tabs {
  gap: 2px;
  border-bottom: 1px solid var(--border);
}

.rt-tabs__tab {
  position: relative;
  padding: 10px 12px;
  font-size: 13.5px;
  font-weight: 500;
  color: var(--text-secondary);
  background: transparent;
  border: none;
  transition: color var(--duration-fast) ease;
}

.rt-tabs__tab:hover {
  color: var(--text-primary);
}

.rt-tabs__tab--active {
  color: var(--text-primary);
  font-weight: 600;
}

.rt-tabs__tab--active::after {
  content: '';
  position: absolute;
  left: 8px;
  right: 8px;
  bottom: 0;
  height: 2px;
  border-radius: 2px;
  background: var(--primary);
}

/* ── Badges ───────────────────────────────────────────────────────── */
.rt-badge {
  height: 22px;
  padding: 0 8px;
  font-size: 11.5px;
  font-weight: 600;
  letter-spacing: 0.01em;
  border-radius: 999px;
}

/* ── Modals, dialogs, drawers ─────────────────────────────────────── */
.rt-dialog-overlay,
.rt-drawer-overlay,
.modal-overlay {
  background: var(--modal-backdrop) !important;
  backdrop-filter: blur(3px);
  -webkit-backdrop-filter: blur(3px);
  animation: rt-fade-in var(--duration-normal) ease;
}

.rt-dialog,
.modal-content {
  background: var(--modal-background) !important;
  color: var(--text-primary);
  border: 1px solid var(--border) !important;
  border-radius: var(--radius-2xl) !important;
  box-shadow: var(--modal-shadow) !important;
  animation: rt-fade-in var(--duration-normal) ease;
}

.rt-dialog {
  animation: rt-dialog-in var(--duration-slow) var(--ease-out);
}

.rt-dialog__title,
.modal-content h2,
.modal-content h3 {
  color: var(--text-primary);
  letter-spacing: -0.01em;
}

.rt-drawer {
  background: var(--modal-background);
  border-left: 1px solid var(--border);
  box-shadow: var(--modal-shadow);
  animation: rt-drawer-in var(--duration-slow) var(--ease-out);
}

.rt-drawer__header,
.rt-drawer__footer {
  border-color: var(--border);
}

.rt-drawer__footer {
  background: var(--surface-raised);
}

@keyframes rt-fade-in {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes rt-dialog-in {
  from { opacity: 0; transform: translateY(8px) scale(0.985); }
  to { opacity: 1; transform: none; }
}

@keyframes rt-drawer-in {
  from { transform: translateX(24px); opacity: 0; }
  to { transform: none; opacity: 1; }
}

/* ── Toasts (react-toast + react-toastify share one look) ─────────── */
html .toast.toast,
html .Toastify__toast.Toastify__toast {
  background: var(--surface-elevated) !important;
  background-image: none !important;
  color: var(--text-primary) !important;
  border: 1px solid var(--border) !important;
  border-left: 3px solid var(--info) !important;
  border-radius: var(--radius-lg) !important;
  box-shadow: var(--shadow-lg) !important;
  font-size: 13.5px;
  line-height: 1.45;
  padding: 12px 14px !important;
}

html .toast .content p,
html .toast.warning .content p {
  color: var(--text-primary) !important;
}

html .toast.toast.success,
html .Toastify__toast--success {
  border-left-color: var(--success) !important;
}

html .toast.toast.error,
html .Toastify__toast--error {
  border-left-color: var(--danger) !important;
}

html .toast.toast.warning,
html .Toastify__toast--warning {
  border-left-color: var(--warning) !important;
}

html .toast.success .icon svg { color: var(--success) !important; fill: currentColor; }
html .toast.error .icon svg { color: var(--danger) !important; fill: currentColor; }
html .toast.warning .icon svg { color: var(--warning) !important; fill: currentColor; }
html .toast.info .icon svg { color: var(--info) !important; fill: currentColor; }

html .toast .close,
html .Toastify__close-button {
  color: var(--text-muted) !important;
  opacity: 1;
}

html .toast .close svg {
  fill: var(--text-muted) !important;
}

html .toast .close:hover {
  background: var(--surface-hover) !important;
}

html .Toastify__progress-bar {
  background: var(--primary) !important;
}

.offline-banner {
  background: color-mix(in srgb, var(--warning) 16%, var(--surface)) !important;
  color: var(--text-primary) !important;
  border-bottom: 1px solid color-mix(in srgb, var(--warning) 35%, transparent) !important;
  font-size: 13px;
  font-weight: 500;
}

/* ── Skeletons ────────────────────────────────────────────────────── */
.rt-skeleton {
  background: linear-gradient(90deg, var(--bg-tertiary) 25%, var(--surface-hover) 50%, var(--bg-tertiary) 75%);
  background-size: 200% 100%;
  animation: rt-skel 1.4s ease-in-out infinite;
}

/* ── Dark mode: neutralise hard-coded light surfaces in app pages ─── */
[data-theme='dark'] .rt2-main [style*='background: white'],
[data-theme='dark'] .rt2-main [style*='background: #fff'],
[data-theme='dark'] .rt2-main [style*='background: rgb(255, 255, 255)'],
[data-theme='dark'] .rt2-main [style*='background-color: white'],
[data-theme='dark'] .rt2-main [style*='background-color: #fff'],
[data-theme='dark'] .rt2-main [style*='background-color: rgb(255, 255, 255)'],
[data-theme='dark'] .rt2-main [style*='background: rgb(248, 250, 252)'],
[data-theme='dark'] .rt2-main [style*='background-color: rgb(248, 250, 252)'],
[data-theme='dark'] .rt2-main [style*='background: rgb(249, 250, 251)'],
[data-theme='dark'] .rt2-main [style*='background-color: rgb(249, 250, 251)'],
[data-theme='dark'] [data-rt-modal-overlay] [style*='background: white'],
[data-theme='dark'] [data-rt-modal-overlay] [style*='background-color: white'],
[data-theme='dark'] [data-rt-modal-overlay] [style*='background: rgb(255, 255, 255)'],
[data-theme='dark'] [data-rt-modal-overlay] [style*='background-color: rgb(255, 255, 255)'] {
  background: var(--surface) !important;
  color: var(--text-primary);
}

[data-theme='dark'] .rt2-main [style*='color: rgb(17, 24, 39)'],
[data-theme='dark'] .rt2-main [style*='color: rgb(31, 41, 55)'],
[data-theme='dark'] .rt2-main [style*='color: rgb(15, 23, 42)'],
[data-theme='dark'] .rt2-main [style*='color: rgb(51, 51, 51)'],
[data-theme='dark'] .rt2-main [style*='color: black'] {
  color: var(--text-primary) !important;
}

[data-theme='dark'] .rt2-main .bg-white,
[data-theme='dark'] .rt2-main .bg-gray-50,
[data-theme='dark'] [data-rt-modal-overlay] .bg-white,
[data-theme='dark'] [data-rt-modal-overlay] .bg-gray-50 {
  background-color: var(--surface) !important;
}

[data-theme='dark'] .rt2-main .bg-gray-100,
[data-theme='dark'] [data-rt-modal-overlay] .bg-gray-100 {
  background-color: var(--bg-tertiary) !important;
}

[data-theme='dark'] .rt2-main .text-gray-900,
[data-theme='dark'] .rt2-main .text-gray-800,
[data-theme='dark'] .rt2-main .text-black,
[data-theme='dark'] [data-rt-modal-overlay] .text-gray-900,
[data-theme='dark'] [data-rt-modal-overlay] .text-gray-800 {
  color: var(--text-primary) !important;
}

[data-theme='dark'] .rt2-main .text-gray-700,
[data-theme='dark'] .rt2-main .text-gray-600,
[data-theme='dark'] [data-rt-modal-overlay] .text-gray-700,
[data-theme='dark'] [data-rt-modal-overlay] .text-gray-600 {
  color: var(--text-secondary) !important;
}

[data-theme='dark'] .rt2-main .text-gray-500,
[data-theme='dark'] [data-rt-modal-overlay] .text-gray-500 {
  color: var(--text-muted) !important;
}

[data-theme='dark'] .rt2-main .border-gray-200,
[data-theme='dark'] .rt2-main .border-gray-300,
[data-theme='dark'] [data-rt-modal-overlay] .border-gray-200,
[data-theme='dark'] [data-rt-modal-overlay] .border-gray-300 {
  border-color: var(--border) !important;
}

[data-theme='dark'] .rt2-main .hover\\:bg-gray-50:hover,
[data-theme='dark'] .rt2-main .hover\\:bg-gray-100:hover {
  background-color: var(--surface-hover) !important;
}

/* Inline "pill" edit buttons that stayed white in dark mode */
[data-theme='dark'] .rt2-main button[style*='background: white'],
[data-theme='dark'] .rt2-main button[style*='background-color: white'],
[data-theme='dark'] .rt2-main button[style*='rgb(255, 255, 255)'] {
  background: var(--primary-muted) !important;
  color: var(--primary-hover) !important;
  border-color: transparent !important;
}

/* ── Topbar ───────────────────────────────────────────────────────── */
.rt2-topbar {
  background: var(--topbar-background);
  border-bottom-color: var(--border);
  backdrop-filter: saturate(160%) blur(10px);
  -webkit-backdrop-filter: saturate(160%) blur(10px);
}

/* ── Motion preferences ───────────────────────────────────────────── */
@media (prefers-reduced-motion: reduce) {
  .rt2-main {
    scroll-behavior: auto;
  }

  .rt-dialog,
  .modal-content,
  .rt-drawer,
  .rt-dialog-overlay,
  .rt-drawer-overlay,
  .modal-overlay,
  .rt-metric-card,
  .rt-skeleton {
    animation: none !important;
    transition: none !important;
  }
}

/* ── Responsive ───────────────────────────────────────────────────── */
@media (max-width: 768px) {
  .rt2-main {
    padding: 16px 14px 28px;
  }

  .rt2-main .rt-page-header {
    flex-direction: column;
    align-items: stretch;
  }

  .rt2-main .rt-page-header__actions {
    flex-wrap: wrap;
  }

  .rt2-main .rt-page-header__title {
    font-size: 20px;
  }

  .rt-search {
    min-width: 0;
    flex: 1 1 100%;
  }

  .rt-filter-bar > .rt-select {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(50% - 8px);
  }
}

/* Tailwind tint utilities → semantic muted tokens in dark mode */
[data-theme='dark'] :is(.rt2-main, [data-rt-modal-overlay]) :is(.bg-blue-50, .bg-blue-100, .bg-indigo-50, .bg-indigo-100, .bg-sky-50) {
  background-color: var(--primary-muted) !important;
}

[data-theme='dark'] :is(.rt2-main, [data-rt-modal-overlay]) :is(.bg-green-50, .bg-green-100, .bg-emerald-50, .bg-emerald-100) {
  background-color: var(--success-muted) !important;
}

[data-theme='dark'] :is(.rt2-main, [data-rt-modal-overlay]) :is(.bg-red-50, .bg-red-100, .bg-rose-50) {
  background-color: var(--danger-muted) !important;
}

[data-theme='dark'] :is(.rt2-main, [data-rt-modal-overlay]) :is(.bg-yellow-50, .bg-yellow-100, .bg-amber-50, .bg-amber-100, .bg-orange-50) {
  background-color: var(--warning-muted) !important;
}

[data-theme='dark'] :is(.rt2-main, [data-rt-modal-overlay]) :is(.bg-purple-50, .bg-purple-100, .bg-violet-50) {
  background-color: rgba(139, 92, 246, 0.16) !important;
}

[data-theme='dark'] :is(.rt2-main, [data-rt-modal-overlay]) :is(.text-blue-700, .text-blue-800, .text-blue-600, .text-indigo-700, .text-indigo-600) {
  color: #93c5fd !important;
}

[data-theme='dark'] :is(.rt2-main, [data-rt-modal-overlay]) :is(.text-green-700, .text-green-800, .text-green-600, .text-emerald-700) {
  color: #86efac !important;
}

[data-theme='dark'] :is(.rt2-main, [data-rt-modal-overlay]) :is(.text-red-700, .text-red-800, .text-red-600) {
  color: #fda4af !important;
}

[data-theme='dark'] :is(.rt2-main, [data-rt-modal-overlay]) :is(.text-yellow-700, .text-yellow-800, .text-amber-700, .text-amber-800, .text-orange-700) {
  color: #fcd34d !important;
}

[data-theme='dark'] :is(.rt2-main, [data-rt-modal-overlay]) :is(.text-purple-700, .text-purple-600, .text-violet-700) {
  color: #c4b5fd !important;
}

[data-theme='dark'] :is(.rt2-main, [data-rt-modal-overlay]) :is(.hover\\:bg-blue-100:hover, .hover\\:bg-blue-50:hover) {
  background-color: rgba(59, 130, 246, 0.24) !important;
}

[data-theme='dark'] :is(.rt2-main, [data-rt-modal-overlay]) :is(.border-blue-200, .border-blue-300) {
  border-color: rgba(59, 130, 246, 0.35) !important;
}

[data-theme='dark'] :is(.rt2-main, [data-rt-modal-overlay]) :is(.border-green-200, .border-red-200, .border-yellow-200, .border-amber-200) {
  border-color: var(--border-strong) !important;
}
`, "",{"version":3,"sources":["webpack://./src/theme/refresh.css"],"names":[],"mappings":"AAAA;;;;EAIE;;AAEF,wEAAwE;AACxE;EACE,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;EAClC,0BAA0B;EAC1B,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA,wEAAwE;AACxE;EACE,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,wBAAwB;EACxB,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;;EAEE,iBAAiB;EACjB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;;EAEE,iCAAiC;EACjC,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;;EAEE,oCAAoC;EACpC,gBAAgB;EAChB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA,wEAAwE;AACxE;;;;;EAKE,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE;oDACkD;AACpD;;AAEA,8DAA8D;AAC9D;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB;iGAC+F;AACjG;;AAEA,2BAA2B,+BAA+B,EAAE;AAC5D,2BAA2B,+BAA+B,EAAE;AAC5D,0BAA0B,8BAA8B,EAAE;AAC1D,2BAA2B,+BAA+B,EAAE;AAC5D,wBAAwB,wBAAwB,EAAE;AAClD,0BAA0B,wBAAwB,EAAE;AACpD,0BAA0B,wBAAwB,EAAE;AACpD;EACE,4GAA4G;AAC9G;AACA,gDAAgD,wBAAwB,EAAE;AAC1E,kDAAkD,wBAAwB,EAAE;AAC5E,kDAAkD,wBAAwB,EAAE;;AAE5E;;EAEE,WAAW;EACX,kBAAkB;EAClB,oBAAoB;EACpB,+CAA+C;EAC/C,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,UAAU;EACV,uHAAuH;EACvH,UAAU;AACZ;;AAEA;EACE,QAAQ;EACR,aAAa;EACb;;;;GAIC;AACH;;AAEA;EACE,yEAAyE;EACzE;;oBAEkB;EAClB,2BAA2B;AAC7B;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,yCAAyC;AAC3C;;AAEA;EACE,4EAA4E;EAC5E,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B;;;;qCAImC;AACrC;;AAEA;EACE,qEAAqE;EACrE,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,WAAW;EACX,UAAU;EACV,2CAA2C;AAC7C;;AAEA;;EAEE,UAAU;EACV,eAAe;AACjB;;AAEA;;EAEE,UAAU;EACV,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,qDAAqD;AACvD;;AAEA;EACE,UAAU;EACV,oBAAoB;EACpB,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,iCAAiC;EACjC,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,+CAA+C;AACjD;;AAEA,4CAA4C,kBAAkB,EAAE;AAChE,4CAA4C,UAAU,EAAE;;AAExD;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,uEAAuE;EACvE,gCAAgC;EAChC,mDAAmD;EACnD,kDAAkD;AACpD;;AAEA;EACE,uEAAuE;AACzE;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;EAClB,4CAA4C;EAC5C,yCAAyC;EACzC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,OAAO,4BAA4B,EAAE;EACrC,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,UAAU,UAAU,EAAE;EACtB,OAAO,UAAU,EAAE;AACrB;;AAEA;EACE;uBACqB,eAAe,EAAE;EACtC;6CAC2C,eAAe,EAAE;AAC9D;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,0BAA0B;EAC1B,uCAAuC;EACvC,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,eAAe;AACjB;;AAEA,wEAAwE;AACxE;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,mCAAmC;EACnC,qCAAqC;EACrC,+BAA+B;EAC/B,0BAA0B;EAC1B,wFAAwF;AAC1F;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;EACvB,wBAAwB;EACxB,2BAA2B;EAC3B,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,cAAc;AAChB;;AAEA;;;;EAIE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;;;;EAIE,0CAA0C;EAC1C,UAAU;AACZ;;AAEA;;EAEE,oDAAoD;EACpD,gDAAgD;EAChD,0CAA0C;EAC1C,wFAAwF;AAC1F;;AAEA;;EAEE,6CAA6C;AAC/C;;AAEA;;EAEE,wBAAwB;EACxB,uCAAuC;EACvC,0CAA0C;AAC5C;;AAEA;;EAEE,oDAAoD;EACpD,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA,mEAAmE;AACnE;;EAGE,gBAAgB;EAChB,yCAAyC;EACzC,0BAA0B;EAC1B,qCAAqC;EACrC,+BAA+B;EAC/B,8BAA8B;EAC9B,yDAAwQ;EACxQ,4BAA4B;EAC5B,sCAAsC;EACtC,qBAAqB;AACvB;;AAEA;;EAEE,mCAAmC;EACnC,0BAA0B;AAC5B;;AAEA;;;;EAIE,4BAA4B;AAC9B;;AAEA,wEAAwE;AACxE;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,gBAAgB;EAChB,wBAAwB;EACxB;8FAC4F;AAC9F;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;EAC1B,WAAW;EACX,qFAAqF;AACvF;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;EAC1B,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;AACjC;;AAEA,oDAAoD;AACpD;;EAEE,qCAAqC;EACrC,uCAAuC;EACvC,sBAAsB;EACtB,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA;;EAEE,2CAA2C;EAC3C,6CAA6C;AAC/C;;AAEA;;;EAGE,qCAAqC;EACrC,iDAAiD;EACjD,qCAAqC;EACrC,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;;;EAGE,2CAA2C;AAC7C;;AAEA;;EAEE,oCAAoC;EACpC,sCAAsC;EACtC,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA,wEAAwE;AACxE;;EAEE,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,iBAAiB;EACjB,0BAA0B;EAC1B,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;;EAEE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;EACxB,0CAA0C;EAC1C,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,4CAA4C;EAC5C,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,gDAAgD;AAClD;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,eAAe;AACjB;;AAEA,uDAAuD;AACvD;EACE,+BAA+B;EAC/B,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA,wEAAwE;AACxE;EACE,QAAQ;EACR,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;EAC5B,uBAAuB;EACvB,YAAY;EACZ,2CAA2C;AAC7C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA,wEAAwE;AACxE;EACE,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA,wEAAwE;AACxE;;;EAGE,4CAA4C;EAC5C,0BAA0B;EAC1B,kCAAkC;EAClC,iDAAiD;AACnD;;AAEA;;EAEE,8CAA8C;EAC9C,0BAA0B;EAC1B,0CAA0C;EAC1C,2CAA2C;EAC3C,0CAA0C;EAC1C,iDAAiD;AACnD;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;;;EAGE,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;EACpC,+BAA+B;EAC/B,4DAA4D;AAC9D;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,KAAK,UAAU,EAAE,eAAe,EAAE;AACpC;;AAEA;EACE,OAAO,2BAA2B,EAAE,UAAU,EAAE;EAChD,KAAK,eAAe,EAAE,UAAU,EAAE;AACpC;;AAEA,wEAAwE;AACxE;;EAEE,8CAA8C;EAC9C,iCAAiC;EACjC,qCAAqC;EACrC,0CAA0C;EAC1C,6CAA6C;EAC7C,0CAA0C;EAC1C,uCAAuC;EACvC,iBAAiB;EACjB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;;EAEE,4CAA4C;AAC9C;;AAEA;;EAEE,2CAA2C;AAC7C;;AAEA;;EAEE,4CAA4C;AAC9C;;AAEA,gCAAgC,gCAAgC,EAAE,kBAAkB,EAAE;AACtF,8BAA8B,+BAA+B,EAAE,kBAAkB,EAAE;AACnF,gCAAgC,gCAAgC,EAAE,kBAAkB,EAAE;AACtF,6BAA6B,6BAA6B,EAAE,kBAAkB,EAAE;;AAEhF;;EAEE,mCAAmC;EACnC,UAAU;AACZ;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,6EAA6E;EAC7E,qCAAqC;EACrC,uFAAuF;EACvF,eAAe;EACf,gBAAgB;AAClB;;AAEA,wEAAwE;AACxE;EACE,4GAA4G;EAC5G,0BAA0B;EAC1B,4CAA4C;AAC9C;;AAEA,wEAAwE;AACxE;;;;;;;;;;;;;;EAcE,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA;;;;;EAKE,qCAAqC;AACvC;;AAEA;;;;EAIE,2CAA2C;AAC7C;;AAEA;;EAEE,+CAA+C;AACjD;;AAEA;;;;;EAKE,qCAAqC;AACvC;;AAEA;;;;EAIE,uCAAuC;AACzC;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;;;;EAIE,sCAAsC;AACxC;;AAEA;;EAEE,iDAAiD;AACnD;;AAEA,8DAA8D;AAC9D;;;EAGE,2CAA2C;EAC3C,sCAAsC;EACtC,oCAAoC;AACtC;;AAEA,wEAAwE;AACxE;EACE,oCAAoC;EACpC,kCAAkC;EAClC,0CAA0C;EAC1C,kDAAkD;AACpD;;AAEA,wEAAwE;AACxE;EACE;IACE,qBAAqB;EACvB;;EAEA;;;;;;;;IAQE,0BAA0B;IAC1B,2BAA2B;EAC7B;AACF;;AAEA,wEAAwE;AACxE;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,YAAyB;IAAzB,cAAyB;IAAzB,2BAAyB;EAC3B;AACF;;AAEA,iEAAiE;AACjE;EACE,iDAAiD;AACnD;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,6CAA6C;AAC/C","sourcesContent":["/*\n * RobiTest design refresh — canonical visual layer over the existing token system.\n * Loaded last (App.js) so it resolves conflicts between ui.css, rt2-primitives.css\n * and legacy page styles. Uses only tokens from theme/tokens.css.\n */\n\n/* ── Base ─────────────────────────────────────────────────────────── */\nhtml {\n  text-rendering: optimizeLegibility;\n}\n\n::selection {\n  background: var(--primary-muted);\n  color: var(--text-primary);\n}\n\n:where(button, a, input, textarea, select, [tabindex]):focus-visible {\n  outline: 2px solid var(--primary);\n  outline-offset: 2px;\n}\n\n.rt2-main {\n  font-size: var(--type-body);\n  line-height: var(--leading-normal);\n  color: var(--text-primary);\n  scroll-behavior: smooth;\n  scrollbar-gutter: stable;\n}\n\n.rt2-main,\n.rt2-main *:not(svg):not(path) {\n  text-shadow: none !important;\n}\n\n/* ── Page chrome ──────────────────────────────────────────────────── */\n.rt2-main .rt-page-header {\n  gap: 16px;\n  margin-bottom: 20px;\n}\n\n.rt2-main .rt-page-header__title {\n  font-size: var(--type-page-title);\n  font-weight: 650;\n  letter-spacing: -0.022em;\n  line-height: var(--leading-tight);\n  color: var(--text-primary);\n}\n\n.rt2-main .rt-page-header__desc,\n.rt2-main .rt-page-header__subtitle {\n  font-size: 13.5px;\n  color: var(--text-secondary);\n  max-width: 68ch;\n}\n\n.rt-breadcrumbs,\n.rt-page-header__crumbs {\n  font-size: var(--type-supporting);\n  color: var(--text-muted);\n}\n\n.rt-breadcrumbs__current {\n  color: var(--text-secondary);\n  font-weight: 600;\n}\n\n.rt2-main .rt-section-header__title,\n.rt2-main .rt-section-card__title {\n  font-size: var(--type-section-title);\n  font-weight: 600;\n  letter-spacing: -0.01em;\n  color: var(--text-primary);\n}\n\n/* ── Surfaces ─────────────────────────────────────────────────────── */\n.rt-section-card,\n.rt-metric-card,\n.rt-context-strip,\n.rt-data-table-wrap,\n.rt-filter-bar {\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-xl);\n  box-shadow: var(--shadow-xs);\n}\n\n.rt-metric-card {\n  transition: border-color var(--duration-normal) ease, box-shadow var(--duration-normal) ease,\n    transform var(--duration-normal) var(--ease-out);\n}\n\n/* Metric cards: accent tone, soft wash, and hover feedback. */\n.rt-metric-card {\n  --metric-accent: #64748b;\n  position: relative;\n  overflow: hidden;\n  isolation: isolate;\n  min-height: 108px;\n  padding: 14px 16px 16px;\n  background:\n    linear-gradient(180deg, color-mix(in srgb, var(--surface) 92%, #fff) 0%, var(--surface) 100%);\n}\n\n.rt-metric-card--primary { --metric-accent: var(--primary); }\n.rt-metric-card--success { --metric-accent: var(--success); }\n.rt-metric-card--danger { --metric-accent: var(--danger); }\n.rt-metric-card--warning { --metric-accent: var(--warning); }\n.rt-metric-card--info { --metric-accent: #0284c7; }\n.rt-metric-card--accent { --metric-accent: #0EA5E9; }\n.rt-metric-card--violet { --metric-accent: #8B5CF6; }\nhtml[data-theme='dark'] .rt-metric-card {\n  background: linear-gradient(180deg, color-mix(in srgb, var(--surface) 88%, #1e293b) 0%, var(--surface) 100%);\n}\nhtml[data-theme='dark'] .rt-metric-card--info { --metric-accent: #38bdf8; }\nhtml[data-theme='dark'] .rt-metric-card--accent { --metric-accent: #38BDF8; }\nhtml[data-theme='dark'] .rt-metric-card--violet { --metric-accent: #A78BFA; }\n\n.rt-metric-card::before,\n.rt-metric-card::after {\n  content: '';\n  position: absolute;\n  pointer-events: none;\n  transition: opacity var(--duration-normal) ease;\n  z-index: -1;\n}\n\n.rt-metric-card::before {\n  inset: 0 0 auto 0;\n  height: 3px;\n  opacity: 1;\n  background: linear-gradient(90deg, var(--metric-accent), color-mix(in srgb, var(--metric-accent) 20%, transparent) 90%);\n  z-index: 1;\n}\n\n.rt-metric-card::after {\n  inset: 0;\n  opacity: 0.55;\n  background: radial-gradient(\n    120% 90% at 100% 0%,\n    color-mix(in srgb, var(--metric-accent) 14%, transparent),\n    transparent 62%\n  );\n}\n\n.rt-metric-card:hover {\n  border-color: color-mix(in srgb, var(--metric-accent) 42%, var(--border));\n  box-shadow:\n    0 14px 30px -16px color-mix(in srgb, var(--metric-accent) 55%, transparent),\n    var(--shadow-sm);\n  transform: translateY(-1px);\n}\n\n.rt-metric-card:hover::after,\n.rt-metric-card:focus-visible::after {\n  opacity: 1;\n}\n\n.rt-metric-card--clickable:hover,\n.rt-metric-card--clickable:focus-visible {\n  transform: translateY(-2px);\n}\n\n.rt-metric-card--clickable:active {\n  transform: translateY(0);\n  transition-duration: var(--duration-fast);\n}\n\n.rt-metric-card--clickable:focus-visible {\n  outline: 2px solid color-mix(in srgb, var(--metric-accent) 60%, transparent);\n  outline-offset: 2px;\n}\n\n.rt-metric-card__badge {\n  position: relative;\n  display: inline-flex;\n  width: 28px;\n  height: 28px;\n  flex-shrink: 0;\n}\n\n.rt-metric-card__badge .rt-metric-card__icon,\n.rt-metric-card__go {\n  position: absolute;\n  inset: 0;\n  width: 28px;\n  height: 28px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: var(--radius-md);\n  transition:\n    opacity var(--duration-normal) ease,\n    transform var(--duration-normal) var(--ease-out),\n    background var(--duration-normal) ease,\n    color var(--duration-normal) ease;\n}\n\n.rt-metric-card__badge .rt-metric-card__icon {\n  background: color-mix(in srgb, var(--metric-accent) 14%, transparent);\n  color: var(--metric-accent);\n}\n\n.rt-metric-card:hover .rt-metric-card__badge .rt-metric-card__icon {\n  background: var(--metric-accent);\n  color: #fff;\n  transform: scale(1.06);\n}\n\n.rt-metric-card__go {\n  background: var(--metric-accent);\n  color: #fff;\n  opacity: 0;\n  transform: translate(-4px, 4px) scale(0.85);\n}\n\n.rt-metric-card--clickable:hover .rt-metric-card__go,\n.rt-metric-card--clickable:focus-visible .rt-metric-card__go {\n  opacity: 1;\n  transform: none;\n}\n\n.rt-metric-card--clickable:hover .rt-metric-card__badge .rt-metric-card__icon,\n.rt-metric-card--clickable:focus-visible .rt-metric-card__badge .rt-metric-card__icon {\n  opacity: 0;\n  transform: translate(4px, -4px) scale(0.85);\n}\n\n.rt-metric-card__body {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 10px;\n  margin-top: auto;\n}\n\n.rt-metric-card__main {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-width: 0;\n}\n\n.rt-metric-card__spark {\n  flex: 0 1 46%;\n  max-width: 128px;\n  min-width: 56px;\n  color: var(--metric-accent);\n}\n\n.rt-sparkline {\n  position: relative;\n  height: 36px;\n  cursor: crosshair;\n}\n\n.rt-sparkline svg {\n  display: block;\n  width: 100%;\n  height: 100%;\n  overflow: visible;\n  animation: rt-spark-reveal 900ms var(--ease-out) both;\n}\n\n.rt-sparkline__line {\n  fill: none;\n  stroke: currentColor;\n  stroke-width: 1.75;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  vector-effect: non-scaling-stroke;\n  transition: stroke-width var(--duration-normal) ease;\n}\n\n.rt-sparkline__area {\n  opacity: 0.75;\n  transition: opacity var(--duration-normal) ease;\n}\n\n.rt-metric-card:hover .rt-sparkline__line { stroke-width: 2.25; }\n.rt-metric-card:hover .rt-sparkline__area { opacity: 1; }\n\n.rt-sparkline__dot {\n  position: absolute;\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: currentColor;\n  box-shadow: 0 0 0 3px color-mix(in srgb, currentColor 22%, transparent);\n  transform: translate(-50%, -50%);\n  transition: left 120ms ease-out, top 120ms ease-out;\n  animation: rt-spark-dot 900ms var(--ease-out) both;\n}\n\n.rt-metric-card:hover .rt-sparkline__dot {\n  box-shadow: 0 0 0 4px color-mix(in srgb, currentColor 28%, transparent);\n}\n\n.rt-sparkline__tip {\n  position: absolute;\n  bottom: calc(100% + 6px);\n  padding: 3px 7px;\n  border-radius: 6px;\n  background: var(--chart-tooltip-bg, #0f172a);\n  color: var(--chart-tooltip-text, #f8fafc);\n  font-size: 11px;\n  font-weight: 600;\n  line-height: 1.4;\n  white-space: nowrap;\n  pointer-events: none;\n  box-shadow: var(--shadow-sm);\n}\n\n.rt-sparkline__tip em {\n  margin-right: 5px;\n  font-style: normal;\n  font-weight: 500;\n  opacity: 0.7;\n}\n\n@keyframes rt-spark-reveal {\n  from { clip-path: inset(0 100% 0 0); }\n  to { clip-path: inset(0 0 0 0); }\n}\n\n@keyframes rt-spark-dot {\n  0%, 70% { opacity: 0; }\n  100% { opacity: 1; }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .rt-sparkline svg,\n  .rt-sparkline__dot { animation: none; }\n  .rt-metric-card--clickable:hover,\n  .rt-metric-card--clickable:focus-visible { transform: none; }\n}\n\n.rt-metric-card__value {\n  font-variant-numeric: tabular-nums;\n  letter-spacing: -0.02em;\n}\n\n.rt-filter-bar {\n  padding: 10px 12px;\n  gap: 8px;\n}\n\n.rt-state {\n  background: var(--surface);\n  border: 1px dashed var(--border-strong);\n  border-radius: var(--radius-xl);\n  padding: 44px 24px;\n}\n\n.rt-state__title {\n  font-size: 15px;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.rt-state__desc {\n  max-width: 44ch;\n  color: var(--text-secondary);\n  font-size: 13px;\n}\n\n/* ── Inputs ───────────────────────────────────────────────────────── */\n.rt-search {\n  height: var(--control-height);\n  min-width: 240px;\n  background: var(--input-background);\n  border: 1px solid var(--input-border);\n  border-radius: var(--radius-md);\n  color: var(--text-primary);\n  transition: border-color var(--duration-fast) ease, box-shadow var(--duration-fast) ease;\n}\n\n.rt-search:focus-within {\n  border-color: var(--primary);\n  box-shadow: var(--shadow-focus);\n}\n\n.rt-search input {\n  background: transparent !important;\n  border: none !important;\n  outline: none !important;\n  box-shadow: none !important;\n  color: var(--text-primary) !important;\n  font-size: var(--text-sm);\n}\n\n.rt-search svg {\n  color: var(--text-muted);\n  flex-shrink: 0;\n}\n\n.rt2-main input:not([type='checkbox']):not([type='radio']):not([type='range']):not([type='color']):not([type='file']),\n.rt2-main textarea,\n.form-input,\n.form-control {\n  color: var(--text-primary);\n  caret-color: var(--primary);\n}\n\n.rt2-main input::placeholder,\n.rt2-main textarea::placeholder,\n.form-input::placeholder,\n.form-control::placeholder {\n  color: var(--input-placeholder) !important;\n  opacity: 1;\n}\n\n.form-input,\n.form-control {\n  background-color: var(--input-background) !important;\n  border: 1px solid var(--input-border) !important;\n  border-radius: var(--radius-md) !important;\n  transition: border-color var(--duration-fast) ease, box-shadow var(--duration-fast) ease;\n}\n\n.form-input:hover:not(:disabled),\n.form-control:hover:not(:disabled) {\n  border-color: var(--border-strong) !important;\n}\n\n.form-input:focus,\n.form-control:focus {\n  outline: none !important;\n  border-color: var(--primary) !important;\n  box-shadow: var(--shadow-focus) !important;\n}\n\n.form-input:disabled,\n.form-control:disabled {\n  background-color: var(--surface-disabled) !important;\n  color: var(--text-muted) !important;\n  cursor: not-allowed;\n}\n\n.form-label {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text-secondary);\n}\n\n/* Remaining native selects: consistent chevron and theme colours */\n.rt2-main select:not([multiple]),\n[data-rt-modal-overlay] select:not([multiple]) {\n  -webkit-appearance: none;\n  appearance: none;\n  background-color: var(--input-background);\n  color: var(--text-primary);\n  border: 1px solid var(--input-border);\n  border-radius: var(--radius-md);\n  padding-right: 32px !important;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%2394A3B8' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 10px center;\n  background-size: 16px;\n}\n\n.rt2-main select option,\n[data-rt-modal-overlay] select option {\n  background: var(--surface-elevated);\n  color: var(--text-primary);\n}\n\n.rt2-main input[type='checkbox'],\n.rt2-main input[type='radio'],\n[data-rt-modal-overlay] input[type='checkbox'],\n[data-rt-modal-overlay] input[type='radio'] {\n  accent-color: var(--primary);\n}\n\n/* ── Buttons ──────────────────────────────────────────────────────── */\n.rt-btn {\n  height: var(--control-height);\n  border-radius: var(--radius-md);\n  font-weight: 600;\n  letter-spacing: -0.005em;\n  transition: background var(--duration-fast) ease, border-color var(--duration-fast) ease,\n    color var(--duration-fast) ease, box-shadow var(--duration-fast) ease, transform 80ms ease;\n}\n\n.rt-btn:active:not(:disabled) {\n  transform: translateY(0.5px);\n}\n\n.rt-btn:focus-visible {\n  outline: none;\n  box-shadow: var(--shadow-focus);\n}\n\n.rt-btn--primary {\n  background: var(--primary);\n  color: #fff;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.12), inset 0 1px 0 rgba(255, 255, 255, 0.08);\n}\n\n.rt-btn--primary:hover:not(:disabled) {\n  background: var(--primary-hover);\n}\n\n.rt-btn--secondary {\n  background: var(--surface);\n  border-color: var(--border-strong);\n  color: var(--text-primary);\n}\n\n.rt-btn--secondary:hover:not(:disabled) {\n  background: var(--surface-hover);\n}\n\n.rt-btn--ghost {\n  background: transparent;\n  border-color: transparent;\n  color: var(--text-secondary);\n}\n\n.rt-btn--ghost:hover:not(:disabled) {\n  background: var(--surface-hover);\n  color: var(--text-primary);\n}\n\n.rt-btn--sm {\n  height: var(--control-height-sm);\n}\n\n.rt-btn--sm.rt-btn--icon {\n  width: var(--control-height-sm);\n}\n\n/* Legacy .btn family aligned with rt-btn variants */\n.rt2-main .btn-primary,\n[data-rt-modal-overlay] .btn-primary {\n  background: var(--primary) !important;\n  border-color: var(--primary) !important;\n  color: #fff !important;\n  box-shadow: none !important;\n  background-image: none !important;\n}\n\n.rt2-main .btn-primary:hover:not(:disabled),\n[data-rt-modal-overlay] .btn-primary:hover:not(:disabled) {\n  background: var(--primary-hover) !important;\n  border-color: var(--primary-hover) !important;\n}\n\n.rt2-main .btn-secondary,\n.rt2-main .btn-outline,\n[data-rt-modal-overlay] .btn-secondary {\n  background: var(--surface) !important;\n  border: 1px solid var(--border-strong) !important;\n  color: var(--text-primary) !important;\n  background-image: none !important;\n  box-shadow: none !important;\n}\n\n.rt2-main .btn-secondary:hover:not(:disabled),\n.rt2-main .btn-outline:hover:not(:disabled),\n[data-rt-modal-overlay] .btn-secondary:hover:not(:disabled) {\n  background: var(--surface-hover) !important;\n}\n\n.rt2-main .btn-danger,\n[data-rt-modal-overlay] .btn-danger {\n  background: var(--danger) !important;\n  border-color: var(--danger) !important;\n  color: #fff !important;\n  background-image: none !important;\n}\n\n/* ── Tables ───────────────────────────────────────────────────────── */\n.rt-data-table-wrap,\n.rt-table-wrap {\n  overflow: auto;\n  max-width: 100%;\n}\n\n.rt-data-table,\n.rt-table {\n  font-size: 13.5px;\n  color: var(--text-primary);\n  border-collapse: separate;\n  border-spacing: 0;\n}\n\n.rt-data-table th,\n.rt-table th {\n  position: sticky;\n  top: 0;\n  z-index: 2;\n  height: 40px;\n  padding: 0 14px;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: var(--text-muted);\n  background: var(--table-header) !important;\n  border-bottom: 1px solid var(--table-border);\n  white-space: nowrap;\n}\n\n.rt-data-table td,\n.rt-table td {\n  padding: 11px 14px;\n  border-bottom: 1px solid var(--table-border);\n  vertical-align: middle;\n  background: transparent;\n}\n\n.rt-data-table tbody tr:last-child td,\n.rt-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.rt-data-table tbody tr,\n.rt-table tbody tr {\n  transition: background var(--duration-fast) ease;\n}\n\n.rt-data-table tbody tr:hover,\n.rt-table tbody tr:hover {\n  background: var(--table-hover);\n}\n\n.rt-data-table__row--clickable,\n.rt-table__row--clickable {\n  cursor: pointer;\n}\n\n/* Generic tables inside the app shell (legacy lists) */\n.rt2-main table:not(.rt-data-table):not(.rt-table) thead th {\n  background: var(--table-header);\n  color: var(--text-muted);\n  border-color: var(--table-border);\n}\n\n.rt2-main table:not(.rt-data-table):not(.rt-table) td {\n  border-color: var(--table-border);\n}\n\n/* ── Tabs ─────────────────────────────────────────────────────────── */\n.rt-tabs {\n  gap: 2px;\n  border-bottom: 1px solid var(--border);\n}\n\n.rt-tabs__tab {\n  position: relative;\n  padding: 10px 12px;\n  font-size: 13.5px;\n  font-weight: 500;\n  color: var(--text-secondary);\n  background: transparent;\n  border: none;\n  transition: color var(--duration-fast) ease;\n}\n\n.rt-tabs__tab:hover {\n  color: var(--text-primary);\n}\n\n.rt-tabs__tab--active {\n  color: var(--text-primary);\n  font-weight: 600;\n}\n\n.rt-tabs__tab--active::after {\n  content: '';\n  position: absolute;\n  left: 8px;\n  right: 8px;\n  bottom: 0;\n  height: 2px;\n  border-radius: 2px;\n  background: var(--primary);\n}\n\n/* ── Badges ───────────────────────────────────────────────────────── */\n.rt-badge {\n  height: 22px;\n  padding: 0 8px;\n  font-size: 11.5px;\n  font-weight: 600;\n  letter-spacing: 0.01em;\n  border-radius: 999px;\n}\n\n/* ── Modals, dialogs, drawers ─────────────────────────────────────── */\n.rt-dialog-overlay,\n.rt-drawer-overlay,\n.modal-overlay {\n  background: var(--modal-backdrop) !important;\n  backdrop-filter: blur(3px);\n  -webkit-backdrop-filter: blur(3px);\n  animation: rt-fade-in var(--duration-normal) ease;\n}\n\n.rt-dialog,\n.modal-content {\n  background: var(--modal-background) !important;\n  color: var(--text-primary);\n  border: 1px solid var(--border) !important;\n  border-radius: var(--radius-2xl) !important;\n  box-shadow: var(--modal-shadow) !important;\n  animation: rt-fade-in var(--duration-normal) ease;\n}\n\n.rt-dialog {\n  animation: rt-dialog-in var(--duration-slow) var(--ease-out);\n}\n\n.rt-dialog__title,\n.modal-content h2,\n.modal-content h3 {\n  color: var(--text-primary);\n  letter-spacing: -0.01em;\n}\n\n.rt-drawer {\n  background: var(--modal-background);\n  border-left: 1px solid var(--border);\n  box-shadow: var(--modal-shadow);\n  animation: rt-drawer-in var(--duration-slow) var(--ease-out);\n}\n\n.rt-drawer__header,\n.rt-drawer__footer {\n  border-color: var(--border);\n}\n\n.rt-drawer__footer {\n  background: var(--surface-raised);\n}\n\n@keyframes rt-fade-in {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes rt-dialog-in {\n  from { opacity: 0; transform: translateY(8px) scale(0.985); }\n  to { opacity: 1; transform: none; }\n}\n\n@keyframes rt-drawer-in {\n  from { transform: translateX(24px); opacity: 0; }\n  to { transform: none; opacity: 1; }\n}\n\n/* ── Toasts (react-toast + react-toastify share one look) ─────────── */\nhtml .toast.toast,\nhtml .Toastify__toast.Toastify__toast {\n  background: var(--surface-elevated) !important;\n  background-image: none !important;\n  color: var(--text-primary) !important;\n  border: 1px solid var(--border) !important;\n  border-left: 3px solid var(--info) !important;\n  border-radius: var(--radius-lg) !important;\n  box-shadow: var(--shadow-lg) !important;\n  font-size: 13.5px;\n  line-height: 1.45;\n  padding: 12px 14px !important;\n}\n\nhtml .toast .content p,\nhtml .toast.warning .content p {\n  color: var(--text-primary) !important;\n}\n\nhtml .toast.toast.success,\nhtml .Toastify__toast--success {\n  border-left-color: var(--success) !important;\n}\n\nhtml .toast.toast.error,\nhtml .Toastify__toast--error {\n  border-left-color: var(--danger) !important;\n}\n\nhtml .toast.toast.warning,\nhtml .Toastify__toast--warning {\n  border-left-color: var(--warning) !important;\n}\n\nhtml .toast.success .icon svg { color: var(--success) !important; fill: currentColor; }\nhtml .toast.error .icon svg { color: var(--danger) !important; fill: currentColor; }\nhtml .toast.warning .icon svg { color: var(--warning) !important; fill: currentColor; }\nhtml .toast.info .icon svg { color: var(--info) !important; fill: currentColor; }\n\nhtml .toast .close,\nhtml .Toastify__close-button {\n  color: var(--text-muted) !important;\n  opacity: 1;\n}\n\nhtml .toast .close svg {\n  fill: var(--text-muted) !important;\n}\n\nhtml .toast .close:hover {\n  background: var(--surface-hover) !important;\n}\n\nhtml .Toastify__progress-bar {\n  background: var(--primary) !important;\n}\n\n.offline-banner {\n  background: color-mix(in srgb, var(--warning) 16%, var(--surface)) !important;\n  color: var(--text-primary) !important;\n  border-bottom: 1px solid color-mix(in srgb, var(--warning) 35%, transparent) !important;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n/* ── Skeletons ────────────────────────────────────────────────────── */\n.rt-skeleton {\n  background: linear-gradient(90deg, var(--bg-tertiary) 25%, var(--surface-hover) 50%, var(--bg-tertiary) 75%);\n  background-size: 200% 100%;\n  animation: rt-skel 1.4s ease-in-out infinite;\n}\n\n/* ── Dark mode: neutralise hard-coded light surfaces in app pages ─── */\n[data-theme='dark'] .rt2-main [style*='background: white'],\n[data-theme='dark'] .rt2-main [style*='background: #fff'],\n[data-theme='dark'] .rt2-main [style*='background: rgb(255, 255, 255)'],\n[data-theme='dark'] .rt2-main [style*='background-color: white'],\n[data-theme='dark'] .rt2-main [style*='background-color: #fff'],\n[data-theme='dark'] .rt2-main [style*='background-color: rgb(255, 255, 255)'],\n[data-theme='dark'] .rt2-main [style*='background: rgb(248, 250, 252)'],\n[data-theme='dark'] .rt2-main [style*='background-color: rgb(248, 250, 252)'],\n[data-theme='dark'] .rt2-main [style*='background: rgb(249, 250, 251)'],\n[data-theme='dark'] .rt2-main [style*='background-color: rgb(249, 250, 251)'],\n[data-theme='dark'] [data-rt-modal-overlay] [style*='background: white'],\n[data-theme='dark'] [data-rt-modal-overlay] [style*='background-color: white'],\n[data-theme='dark'] [data-rt-modal-overlay] [style*='background: rgb(255, 255, 255)'],\n[data-theme='dark'] [data-rt-modal-overlay] [style*='background-color: rgb(255, 255, 255)'] {\n  background: var(--surface) !important;\n  color: var(--text-primary);\n}\n\n[data-theme='dark'] .rt2-main [style*='color: rgb(17, 24, 39)'],\n[data-theme='dark'] .rt2-main [style*='color: rgb(31, 41, 55)'],\n[data-theme='dark'] .rt2-main [style*='color: rgb(15, 23, 42)'],\n[data-theme='dark'] .rt2-main [style*='color: rgb(51, 51, 51)'],\n[data-theme='dark'] .rt2-main [style*='color: black'] {\n  color: var(--text-primary) !important;\n}\n\n[data-theme='dark'] .rt2-main .bg-white,\n[data-theme='dark'] .rt2-main .bg-gray-50,\n[data-theme='dark'] [data-rt-modal-overlay] .bg-white,\n[data-theme='dark'] [data-rt-modal-overlay] .bg-gray-50 {\n  background-color: var(--surface) !important;\n}\n\n[data-theme='dark'] .rt2-main .bg-gray-100,\n[data-theme='dark'] [data-rt-modal-overlay] .bg-gray-100 {\n  background-color: var(--bg-tertiary) !important;\n}\n\n[data-theme='dark'] .rt2-main .text-gray-900,\n[data-theme='dark'] .rt2-main .text-gray-800,\n[data-theme='dark'] .rt2-main .text-black,\n[data-theme='dark'] [data-rt-modal-overlay] .text-gray-900,\n[data-theme='dark'] [data-rt-modal-overlay] .text-gray-800 {\n  color: var(--text-primary) !important;\n}\n\n[data-theme='dark'] .rt2-main .text-gray-700,\n[data-theme='dark'] .rt2-main .text-gray-600,\n[data-theme='dark'] [data-rt-modal-overlay] .text-gray-700,\n[data-theme='dark'] [data-rt-modal-overlay] .text-gray-600 {\n  color: var(--text-secondary) !important;\n}\n\n[data-theme='dark'] .rt2-main .text-gray-500,\n[data-theme='dark'] [data-rt-modal-overlay] .text-gray-500 {\n  color: var(--text-muted) !important;\n}\n\n[data-theme='dark'] .rt2-main .border-gray-200,\n[data-theme='dark'] .rt2-main .border-gray-300,\n[data-theme='dark'] [data-rt-modal-overlay] .border-gray-200,\n[data-theme='dark'] [data-rt-modal-overlay] .border-gray-300 {\n  border-color: var(--border) !important;\n}\n\n[data-theme='dark'] .rt2-main .hover\\:bg-gray-50:hover,\n[data-theme='dark'] .rt2-main .hover\\:bg-gray-100:hover {\n  background-color: var(--surface-hover) !important;\n}\n\n/* Inline \"pill\" edit buttons that stayed white in dark mode */\n[data-theme='dark'] .rt2-main button[style*='background: white'],\n[data-theme='dark'] .rt2-main button[style*='background-color: white'],\n[data-theme='dark'] .rt2-main button[style*='rgb(255, 255, 255)'] {\n  background: var(--primary-muted) !important;\n  color: var(--primary-hover) !important;\n  border-color: transparent !important;\n}\n\n/* ── Topbar ───────────────────────────────────────────────────────── */\n.rt2-topbar {\n  background: var(--topbar-background);\n  border-bottom-color: var(--border);\n  backdrop-filter: saturate(160%) blur(10px);\n  -webkit-backdrop-filter: saturate(160%) blur(10px);\n}\n\n/* ── Motion preferences ───────────────────────────────────────────── */\n@media (prefers-reduced-motion: reduce) {\n  .rt2-main {\n    scroll-behavior: auto;\n  }\n\n  .rt-dialog,\n  .modal-content,\n  .rt-drawer,\n  .rt-dialog-overlay,\n  .rt-drawer-overlay,\n  .modal-overlay,\n  .rt-metric-card,\n  .rt-skeleton {\n    animation: none !important;\n    transition: none !important;\n  }\n}\n\n/* ── Responsive ───────────────────────────────────────────────────── */\n@media (max-width: 768px) {\n  .rt2-main {\n    padding: 16px 14px 28px;\n  }\n\n  .rt2-main .rt-page-header {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .rt2-main .rt-page-header__actions {\n    flex-wrap: wrap;\n  }\n\n  .rt2-main .rt-page-header__title {\n    font-size: 20px;\n  }\n\n  .rt-search {\n    min-width: 0;\n    flex: 1 1 100%;\n  }\n\n  .rt-filter-bar > .rt-select {\n    flex: 1 1 calc(50% - 8px);\n  }\n}\n\n/* Tailwind tint utilities → semantic muted tokens in dark mode */\n[data-theme='dark'] :is(.rt2-main, [data-rt-modal-overlay]) :is(.bg-blue-50, .bg-blue-100, .bg-indigo-50, .bg-indigo-100, .bg-sky-50) {\n  background-color: var(--primary-muted) !important;\n}\n\n[data-theme='dark'] :is(.rt2-main, [data-rt-modal-overlay]) :is(.bg-green-50, .bg-green-100, .bg-emerald-50, .bg-emerald-100) {\n  background-color: var(--success-muted) !important;\n}\n\n[data-theme='dark'] :is(.rt2-main, [data-rt-modal-overlay]) :is(.bg-red-50, .bg-red-100, .bg-rose-50) {\n  background-color: var(--danger-muted) !important;\n}\n\n[data-theme='dark'] :is(.rt2-main, [data-rt-modal-overlay]) :is(.bg-yellow-50, .bg-yellow-100, .bg-amber-50, .bg-amber-100, .bg-orange-50) {\n  background-color: var(--warning-muted) !important;\n}\n\n[data-theme='dark'] :is(.rt2-main, [data-rt-modal-overlay]) :is(.bg-purple-50, .bg-purple-100, .bg-violet-50) {\n  background-color: rgba(139, 92, 246, 0.16) !important;\n}\n\n[data-theme='dark'] :is(.rt2-main, [data-rt-modal-overlay]) :is(.text-blue-700, .text-blue-800, .text-blue-600, .text-indigo-700, .text-indigo-600) {\n  color: #93c5fd !important;\n}\n\n[data-theme='dark'] :is(.rt2-main, [data-rt-modal-overlay]) :is(.text-green-700, .text-green-800, .text-green-600, .text-emerald-700) {\n  color: #86efac !important;\n}\n\n[data-theme='dark'] :is(.rt2-main, [data-rt-modal-overlay]) :is(.text-red-700, .text-red-800, .text-red-600) {\n  color: #fda4af !important;\n}\n\n[data-theme='dark'] :is(.rt2-main, [data-rt-modal-overlay]) :is(.text-yellow-700, .text-yellow-800, .text-amber-700, .text-amber-800, .text-orange-700) {\n  color: #fcd34d !important;\n}\n\n[data-theme='dark'] :is(.rt2-main, [data-rt-modal-overlay]) :is(.text-purple-700, .text-purple-600, .text-violet-700) {\n  color: #c4b5fd !important;\n}\n\n[data-theme='dark'] :is(.rt2-main, [data-rt-modal-overlay]) :is(.hover\\:bg-blue-100:hover, .hover\\:bg-blue-50:hover) {\n  background-color: rgba(59, 130, 246, 0.24) !important;\n}\n\n[data-theme='dark'] :is(.rt2-main, [data-rt-modal-overlay]) :is(.border-blue-200, .border-blue-300) {\n  border-color: rgba(59, 130, 246, 0.35) !important;\n}\n\n[data-theme='dark'] :is(.rt2-main, [data-rt-modal-overlay]) :is(.border-green-200, .border-red-200, .border-yellow-200, .border-amber-200) {\n  border-color: var(--border-strong) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
